import { configureStore } from '@reduxjs/toolkit';
import { Api } from './api';
import globalReducers from './globalSlices';
import patientReducers from '@pages/Patients/PatientProfile/PatientDetailsTab/patientSlice';
import userReducers from '@components/InviteCode/userSlice';
import bulkSearchReducers from './bulkSearchSlice';
/**
 * Redux store configuration
 */
const store = configureStore({
  reducer: {
    [Api.reducerPath]: Api.reducer,
    global: globalReducers,
    patient: patientReducers,
    user: userReducers,
    bulkSearch: bulkSearchReducers,
  },
  middleware: (gDM) => gDM().concat(Api.middleware),
});

export default store;
